import React, { useState, useEffect, useRef } from 'react';
import {
  CustomerServiceOutlined,
  CloseOutlined,
  PhoneOutlined,
  MailOutlined,
} from '@ant-design/icons';
import './HelpWidget.css';

const SUPPORT_CONTACTS = {
  phone: '+7 (930) 035-79-09',
  phoneHref: 'tel:+79300357909',
  email: 'fixator@buyrights.ru',
  emailHref: 'mailto:fixator@buyrights.ru',
};

const HelpWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (widgetRef.current && !widgetRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <div
      ref={widgetRef}
      className={`help-widget${isOpen ? ' help-widget--open' : ''}`}
    >
      <button
        type="button"
        className="help-widget__tab"
        onClick={toggle}
        aria-expanded={isOpen}
        aria-label="Нужна помощь?"
      >
        <CustomerServiceOutlined className="help-widget__tab-icon" />
        <span className="help-widget__tab-text">Нужна помощь?</span>
      </button>

      <div className="help-widget__panel" aria-hidden={!isOpen}>
        <div className="help-widget__panel-header">
          <h2 className="help-widget__title">Нужна помощь?</h2>
          <button
            type="button"
            className="help-widget__close"
            onClick={() => setIsOpen(false)}
            aria-label="Закрыть"
          >
            <CloseOutlined />
          </button>
        </div>

        <div className="help-widget__warning">
          ⚠ Возникла ошибка — свяжитесь с нами, поможем разобраться
        </div>

        <div className="help-widget__contacts">
          <a href={SUPPORT_CONTACTS.phoneHref} className="help-widget__contact">
            <PhoneOutlined className="help-widget__contact-icon" />
            <span>
              <span className="help-widget__contact-value">{SUPPORT_CONTACTS.phone}</span>
              <span className="help-widget__contact-note">Звонок по России бесплатный</span>
            </span>
          </a>

          <a href={SUPPORT_CONTACTS.emailHref} className="help-widget__contact">
            <MailOutlined className="help-widget__contact-icon" />
            <span className="help-widget__contact-value">{SUPPORT_CONTACTS.email}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpWidget;
